

function View({ }) {
    return (
        <p></p>
    )
}

export const EnrolmentRequestDetail = View;